import { memo } from 'react'

type IconProps = {
  className?: string
  fill?: string
  viewBox?: string
}

const PlusIcon = ({ className = 'w-6 h-6', fill = 'none', viewBox = '0 0 24 24' }: IconProps) => (
  <svg fill={fill} viewBox={viewBox} strokeWidth={1.5} className={className}>
    <path strokeLinecap='round' strokeLinejoin='round' d='M12 6v12m6-6H6' />
  </svg>
)
export default memo(PlusIcon)
